@if (showSpinner) {
  <div class="overlaySpinner">
    <div class="spinner-loading">
      <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
}
